/*global _ */
import {fv} from '../../../../lib/utils'

import InputMixin from '../../../../mixins/form/input-options'
import DesignerMixin from './designer'
const mixins = [InputMixin, DesignerMixin]

export default {
  name: 're-radios',
  mixins,
  props: {
    radioValue: {
      type: [String, Number],
      default: null
    },
    inputClass: {
      type: String,
      default: 'form-control-radios'
    },
  },
  computed: {
    hasBlankOption() {
      return !_.isNil(this.blankOption)
    },
    modelLabel() {
      return (_.find(this.optionsList, o => o.value === this.model) || {}).label
    }
  },
  methods: {
    getInputProps(item, key, isComponent) {
      const label =  _.isString(item) ? item : fv(item.label || _.startCase(key))
      const radioValue = fv(item.value, key)
      const selected = radioValue === this.model
      const classes = [_.kebabCase(`form-field-${label}`), {selected}]

      const mapValue = (values) => {
        if (_.isArray(values)) {
          return _.map(values, mapValue)
        }
        if (_.isObject(values)) {
          return _.mapValues(values, i => {
            if (_.isObject(i)) {
              return mapValue(i)
            }
            if (i === '$item') {
              return {key, ..._.cloneDeep(item), selected}
            }
            if (i === '$value') {
              return radioValue
            }
            if (i === '$model') {
              return this.model
            }
            return i
          })
        }
        return values
      }
      const attrs = _.merge(
        {},
        mapValue(this.inputComponentAttrs || {}),
        selected ? mapValue(this.inputSelectedComponentAttrs || {}) : {}
      )
      if (isComponent) {
        attrs.context = this.context || this.$parent
      }
      return {
        showErrors: false,
        multi: true,
        name: this.name,
        id: item.id || null,
        radioValue,
        label,
        class: classes,
        tabindex: this.tabindex,
        ...attrs
      }
    },
    onInput(value, item) {
      this.isDirtyState = true
      this.innerValue = value
      this.$emit('input', value, item)
    },
    getLabelExtraClasses() {
      return [`re-input-label-radios`]
    }
  }
}
